import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ChecklistEffects } from './checklist.effects';
import { reducer } from './checklist.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('checklist', reducer),
    EffectsModule.forFeature([ChecklistEffects]),
  ],
  providers: [ChecklistEffects],
})
export class ChecklistStoreModule {}
